export const PRODUCT_TYPES = {
    VOICE: 'VOICE_CALLS',
    VIDEO: 'VIDEO_CALLS',
};

export const VIDEO_CALL = {
    VIDEO_CALL_INSIGHTS: 'Video_Call_Insights',
    MAX_NO_OF_MINUTES_PER_CALL: 120,
    MIN_NO_OF_MINUTES_PER_CALL: 0,
    MAX_NO_OF_MINUTES_PER_DAY_PER_LEARNER: 600,
    MIN_NO_OF_MINUTES_PER_DAY_PER_LEARNER: 0,
    MAX_NO_SLOTS_IN_DAY: 4,
    MIN_SLOT_DURATION: 30,
    VIDEO_CALL_DURATION_ATTRIBUTE_KEY: 'Video_Call_Duration',
    VIDEO_CALL_MAX_MIN_PER_DAY_PER_LEARNER_ATTRIBUTE_KEY: 'Video_MaxMinPerDayPerLearner',
    VIDEO_CALL_GROUP_SCHEDULE_DEFAULT_ATTRIBUTE_KEY: 'VIDEO_CALL_GROUP_SCHEDULE_DEFAULT',
    DAY_OF_WEEK_MAP: {
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        7: 'Sunday'
    },
    getRelationshipTypes: () => {
        return [
            { value: 'Friend', id: 'friend', backendValue: 'FRIEND' },
            { value: 'Family', id: 'family', backendValue: 'FAMILY' },
            { value: 'General Contact', id: 'general-contact', backendValue: 'GENERAL_CONTACT' },
            { value: 'Attorney', id: 'attorney', backendValue: 'ATTORNEY' },
            { value: 'Probation / Parole Officer', id: 'probation-officer', backendValue: 'PROBATION_PAROLE_OFFICER' },
            { value: 'Medical', id: 'medical', backendValue: 'MEDICAL' },
            { value: 'General Privileged Contact', id: 'general-privileged-contact', backendValue: 'GENERAL_PRIVILEGED_CONTACT' },
        ];
    },
    getPrivilegeRelationShipTypes: () => {
        return ['ATTORNEY', 'MEDICAL', 'GENERAL PRIVILEGED CONTACT'];
    }
}
